import {
    Validators,
    AbstractControl,
    ValidatorFn,
    ValidationErrors,
  } from '@angular/forms';
  
  import { isPresent } from '../utils/is-present';
  
  export const addressLine1 : ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    if (isPresent(Validators.required(control))) {
      return null;
    }
  
    const v: string = control.value;
    return /^[A-Za-z0-9'\.\-\s\,]*$/g.test(v)
      ? null
      : { addressLine1: true };
  };
  